import React from "react";
import { Delta } from "./Delta.jsx";
import { Icon } from "../core/Icon.jsx";

/* Stat — headline metric: label, big value, optional delta + caption.
   Use for balances, NAV, totals. Big numerals are a display moment. */
export function Stat({ label, value, prefix, suffix, delta, deltaSuffix, caption, icon, size = "md", style, ...rest }) {
  const fs = size === "lg" ? 40 : size === "sm" ? 24 : 30;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, ...style }} {...rest}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {icon ? <Icon name={icon} size={16} color="var(--text-muted)" /> : null}
        <span style={{ fontFamily: "var(--font-sans)", fontWeight: 600, fontSize: 13, color: "var(--text-muted)" }}>{label}</span>
      </div>
      <div className="tnum" style={{ display: "flex", alignItems: "baseline", gap: 4, fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: fs, letterSpacing: "-0.02em", color: "var(--text-strong)", lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>
        {prefix ? <span style={{ fontSize: fs * 0.62, fontWeight: 700, color: "var(--text-muted)" }}>{prefix}</span> : null}
        {value}
        {suffix ? <span style={{ fontSize: fs * 0.5, fontWeight: 600, color: "var(--text-muted)" }}>{suffix}</span> : null}
      </div>
      {delta != null || caption ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {delta != null ? <Delta value={delta} suffix={deltaSuffix ?? "%"} size="sm" /> : null}
          {caption ? <span style={{ fontFamily: "var(--font-sans)", fontWeight: 500, fontSize: 12, color: "var(--text-muted)" }}>{caption}</span> : null}
        </div>
      ) : null}
    </div>
  );
}

export default Stat;
